<template>
    <el-dialog
            :title="tips"
            class="cropDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="isShow"
            :width="dw"
    >
        <div class="crop">
            <div class="crop-img">
                <vue-cropper ref="cropper"
                             :img="option.img"
                             :output-size="option.size"
                             :output-type="option.outputType"
                             :info="true"
                             :enlarge="option.enlarge"
                             :full="option.full" :fixed="option.fixed"
                             :fixed-number="option.fixedNumber"
                             :can-move="option.canMove"
                             :can-move-box="option.canMoveBox"
                             :fixed-box="option.fixedBox" :original="option.original"
                             :auto-crop="option.autoCrop" :auto-crop-width="option.autoCropWidth"
                             :auto-crop-height="option.autoCropHeight"
                             :center-box="option.centerBox"
                             @real-time="realTime" :high="option.high"
                             @img-load="imgLoad" mode="cover">
                </vue-cropper>
                <div class="top-button" >
                    <span @click="changeScale(1)" class=" btn">
                         <v-icon name="search-plus"
                                 scale="1.2"
                         ></v-icon>
                    </span>
                    <span @click="changeScale(-1)" class="btn">
                         <v-icon name="search-minus"
                                 scale="1.2"
                         ></v-icon>
                    </span>
                    <span class="btn"   @click="rotateLeft" style="transform: rotateY(180deg)">
                         <v-icon name="redo"
                                 scale="1.1"
                         ></v-icon>
                    </span>
                    <span class="btn"  @click="rotateRight">
                         <v-icon name="redo"
                                 scale="1.1"></v-icon>
                    </span>
                </div>
                <div>
                    <p style="text-align: center;font-size: 16px;color: red">拖动鼠标滚动轴调整大小</p>
                </div>
            </div>
            <div class="left" >
                <div class="show-img" :style="{'width': width + 'px', 'height': height + 'px'}" >
                    <div class="show-preview" :style="{'width': previews.w + 'px', 'height': previews.h + 'px',
   'overflow': 'hidden', }">
                        <div :style="previews.div">
                            <img :src="previews.url" :style="previews.img"  style="max-width: none">
                        </div>
                    </div>
                </div>
                <p style="text-align: center;color: red;line-height: 30px" v-if="photoType === 'photo'">执照照片印刷预览</p>
                <p style="text-align: center;color: red;line-height: 30px" v-else>图片裁剪预览</p>
                <div v-if="photoType === 'photo'">
                    <img :src="examplePhoto" alt="" style="max-width:none;width: 250px">
                </div>
                <div v-if="photoType === 'Card'">
                    <img :src="idcard_front" alt="" style="max-width:none;width: 250px" v-if="cardType === 'identify_edit1'">
                    <img :src="idcard_end" alt="" style="max-width:none;width: 250px" v-else>
                </div>
                <div class="btns " style="display: flex;justify-content: center">
                    <el-button type="danger" @click="isShow=false">取消</el-button>
                    <el-button type="primary" style="margin-left: 50px" @click="saveImg">保存</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
  import { VueCropper } from 'vue-cropper'
    import "vue-awesome/icons/redo";
    import "vue-awesome/icons/redo";
    import "vue-awesome/icons/search-plus";
    import "vue-awesome/icons/search-minus";
    import examplePhoto from "@/assets/images/examplePhoto.png";
    import idcard_front from "@/assets/images/vita/idcard_front.png";
    import idcard_end from "@/assets/images/vita/idcard_end.png";

    export default {
        name: 'upload',
        data() {
            return {
                previews: {},
                examplePhoto,
              idcard_front,
              idcard_end,
            }
        },
        props: {
            option: {
                type: Object,
                required: true,
            },
            show:{
                type: Boolean,
                required: true,
                default: false,
            },
            tips: {
                type: String,
                required: false,
                default: '调整照片',
            },
            dw: {
                type: String,
                required: false,
                default: '800px'
            },
            width:{
                type: String,
                required: false,
                default: '149'
            },
            height:{
                type: String,
                required: false,
                default: '208'
            },
          photoType: {
            type: String,
            default: 'Card'
          },
          cardType: {
            type: String,
            default: 'identify_edit1'
          }
        },
      mounted() {
//        this.$refs.cropper.getZoom().then(minZoom => {
//          this.$refs.cropper.zoomTo(minZoom);
//        });
        this.$nextTick(() => {
          console.log(this.$refs.cropper)
        });
        
      },
        methods: {
            imgLoad(msg) {

            },
            realTime(data) {
                this.previews = data;
            },
           blobToFile(blob, fileName){
                blob.lastModifiedDate =new Date();
                blob.name = fileName;
                return blob;
            },
            saveImg(){
                this.$refs.cropper.getCropData((data)=>{
                    this.$emit('hideCropper',false,data)
                })
            },
            changeScale(num) {
                const newNum = num || 1;
                // num = num || 1
                this.$refs.cropper.changeScale(newNum);
            },
            rotateLeft() {
                this.$refs.cropper.rotateLeft();
            },
            rotateRight() {
                this.$refs.cropper.rotateRight();
            },
        },
        computed: {
            isShow: {
                get() {
                    return this.show
                },
                set(val) {
                    this.$emit('update:show',val)
                }
            }
        },
        components:{
            "v-icon": () => import("vue-awesome/components/Icon"),
          VueCropper
        }
    };
</script>


<style scoped lang="stylus">
    .crop
        display flex
        justify-content space-between
        height 500px
        .crop-img
            width 450px
            height 410px
            padding 10px
            .top-button
                margin-top 10px
                display flex
                align-items center
                justify-content center
                .btn
                    cursor pointer
                    font-size 22px
                    margin 0 25px 0 25px
        .left

            width: 300px;
            padding: 10px 0 0 30px
            .show-img
                margin 0 auto
                border 1px solid black



</style>

<style lang="stylus">
    .cropDialog
        .el-dialog__body
            padding 0 20px 20px 20px
</style>
